import { Component } from '@angular/core';

@Component({
  selector: 'om-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: true,
})
export class LogoComponent {}
